import classNames from 'classnames'
import { FormSubmitButton, TrustArcLogo } from '@common/components'
import { connectRedux, GoToComponentProps } from '@common/utils'
import { ConnectedLmiProOrderSummary } from '@lmipro/connectedComponents'
import {
    LmiProCheckoutFormSubmissionActionsType,
    mapLmiProCheckoutFormSubmissionActions,
    mapLmiProCheckoutFormSubmissionState,
} from '@lmipro/connectedComponents/CheckoutFormSubmission/connector'
import { LmiProCheckoutFormSubmissionState } from '@lmipro/connectedComponents/CheckoutFormSubmission/state'

import React, { FunctionComponent } from 'react'
import checkoutFormStyles from './checkout-form-submit.css'
import billingStyles from '../../views/Billing/billing.module.css'

export interface LmiProCheckoutFormSubmissionComponentProps {
    isSubmitting: boolean
    preSubmit: () => void
    isTabletOrMobileView?: boolean | undefined
    inlineErrors: { [key: string]: string } | Record<string, unknown>
}
type LmiProCheckoutFormSubmissionProps = GoToComponentProps<
    LmiProCheckoutFormSubmissionState,
    LmiProCheckoutFormSubmissionActionsType,
    LmiProCheckoutFormSubmissionComponentProps
>

export const LmiProCheckoutFormSubmission: FunctionComponent<LmiProCheckoutFormSubmissionProps> = ({
    state,
    props,
}) => {
    const { content, isFatalError, fatalErrorBlocker, totalLoading, calculatedTotal, disablePlanSelection } = state
    const { isSubmitting, preSubmit, isTabletOrMobileView, inlineErrors } = props
    const submitBtnStyles = classNames({
        [billingStyles['lmipro-custom-submit-btn']]: true,
        [billingStyles['common-submit-btn']]: true,
        [checkoutFormStyles.submit]: true,
    })

    return (
        <>
            {!isTabletOrMobileView ? (
                <>
                    <FormSubmitButton
                        modifier={submitBtnStyles}
                        disabled={
                            isSubmitting ||
                            fatalErrorBlocker ||
                            totalLoading ||
                            (inlineErrors && !!Object.keys(inlineErrors).length) ||
                            (calculatedTotal === 0 && disablePlanSelection)
                        }
                        isSubmitting={isSubmitting}
                        type="button"
                        onClick={() => {
                            preSubmit()
                        }}
                        text={content.completePurchase}
                    />
                </>
            ) : (
                <>
                    <ConnectedLmiProOrderSummary isTabletOrMobileView />
                    <FormSubmitButton
                        modifier={submitBtnStyles}
                        disabled={
                            isSubmitting ||
                            isFatalError ||
                            fatalErrorBlocker ||
                            totalLoading ||
                            (inlineErrors && !!Object.keys(inlineErrors).length) ||
                            (calculatedTotal === 0 && disablePlanSelection)
                        }
                        isSubmitting={isSubmitting}
                        type="button"
                        onClick={() => {
                            preSubmit()
                        }}
                        text={content.completePurchase}
                    />
                    <TrustArcLogo />
                </>
            )}
        </>
    )
}

export const ConnectedLmiProCheckoutFormSubmission = connectRedux(
    LmiProCheckoutFormSubmission,
    mapLmiProCheckoutFormSubmissionState,
    mapLmiProCheckoutFormSubmissionActions
)
